// extracted by mini-css-extract-plugin
export default {"box":"diff-section_box__DdUfA"};